import api from './index';

const profileAPI = {
  // Get applicant profile with user data
  getProfile: (applicantId) => {
    return api.get(`/applicants/${applicantId}?include_user=true`);
  },
  
  // Get user data separately if needed
  getUserData: () => {
    return api.get('/applicants/user');
  },
  
  // Update applicant profile
  updateProfile: (applicantId, profileData) => {
    return api.put(`/applicants/${applicantId}`, profileData);
  },
  
  // Upload CV
  uploadCV: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    
    return api.post('/files', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  
  // Check if applicant has recent CV
  checkRecentCV: () => {
    return api.get('/files/check_recent');
  }
};

export default profileAPI;
